import styled from '@emotion/styled'
import { ITheme } from 'utils/type'

interface IInputProps {
  theme: ITheme
}

export const WarningIcon = styled.img`
  label: WarningIcon;
  padding-right: 6px;
  margin-bottom: 3px;
`

export const TextAreaLength = styled.span<IInputProps>`
  label: TextAreaLength;
  float: right;
  font-size: 12px;
  color: ${(props) => props.theme.colors.textDarkblack} !important;
  margin-top: 6px;
`
